import React, { useEffect, useState } from 'react';
import { Notification } from 'components';

import MessagePrepIcon from 'assests/icons/message-prep.icon';
import CheckBorderIcon from 'assests/icons/check-border.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import RejectedBorderIcon from 'assests/icons/rejected-border.icon';
import CloseIcon from 'assests/icons/close.icon';
import UploadFileIcon from 'assests/icons/upload-file.icon';
import { Button } from '../index';
import classNames from 'classnames';

import './select-file.less';
import '../MessageList/message-list.less';
import { message, Modal } from 'antd';
import DeleteIcon from 'assests/icons/delete.icon';

const SelectFile = ({errorMessage="Desteklenmeyen Dosya Türü",allowExtensions=["xlsx","xls"], ...props}) => {
  const [modalReadyMessages, setModalReadyMessages] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState('');
  const [selectFile, setSelectFile] = useState('');
  const [rejected, setRejected] = useState(props.rejected);

  const [fileList, setFileList] = useState(props.fileList);

  useEffect(() => {
    if (props.fileList.length > 0) {
      setFileList(props.fileList);
      uploadFile(props.fileList);
    }
  }, [props.fileList]);

  function selectMessage(message) {
    setSelectedMessage(message);
    props.onChange(message);
  }

  function uploadFile(files) {
    const file = files[0];
    setSelectFile(file.name);
    setRejected(false);

    if (props.notification) {
      Notification(
        props.notificationplacement,
        file.name,
        'notification notification--success',
        props.notificationMessage,
        'success'
      );
    }
  }

  function inputOnChange(e) {
    let fileList = e.target.files;
    let file = fileList[0];
    let extension = file.name.split('.').pop().toLowerCase(); // assuming that this file has any extension
    if (allowExtensions.includes(extension))
    {
    const files = document.querySelector(
      'input[name=' + props.typeName + ']'
    ).files;

    setFileList(files);
    uploadFile(files);
    e.files = files;
    }
    else
    {
      message.error(errorMessage);
    }
  }

  return (
    <div
      {...props}
      className={classNames(
        'select-ready-messages',
        props.compClass,
        { uploaded: selectFile || selectedMessage },
        { 'select-ready-messages--vertical': props.vertical },
        { 'select-ready-messages--iconless': props.iconless },
        { 'select-ready-messages--v2': props.typeV2 },
        { 'select-ready-messages--rejected': props.rejected }
      )}
    >
      {props.type === 'file' ? (
        <>
          {props.iconless ? null : (
            <div className="status">
              {rejected ? (
                <RejectedBorderIcon />
              ) : (
                <>{selectFile ? <CheckBorderIcon /> : props.icon}</>
              )}
            </div>
          )}
          <div className="messages-area">
            {rejected ? (
              <>
                <span>Reddedildi</span>
                <p>vergilevhasiuzunmeti…jpg</p>
              </>
            ) : (
              <>
                {selectFile ? (
                  <>
                    <span>Dosya Yüklendi</span>
                    <p>{selectFile}</p>
                  </>
                ) : (
                  props.title
                )}
              </>
            )}
          </div>
          <div className="upload-action">
            {rejected ? (
              <UploadFileIcon />
            ) : (
              <>
                {props.uploaderRef ? (
                  <Button
                    type="ghost"
                    onClick={() => {
                      props.uploaderRef.current.click();
                    }}
                  >
                    {selectFile ? 'Değiştir...' : 'Seç...'}
                  </Button>
                ) : (
                  <Button type="ghost">
                    {selectFile ? 'Değiştir...' : 'Seç...'}
                  </Button>
                )}
              </>
            )}

            <input
              type="file"
              name={props.typeName}
              id={props.id}
              onChange={inputOnChange}
            />
          </div>
        </>
      ) : (
        <>
          <div className="status">
            {selectedMessage ? <CheckBorderIcon /> : <MessagePrepIcon />}
          </div>
          <div className="messages-area">
            {selectedMessage ? (
              <>
                <span>Hazır Mesaj Seçildi</span>
                <p>{selectedMessage}</p>
              </>
            ) : (
              <span>Hazır Mesajlardan Seç ve Kullan</span>
            )}
          </div>
          <Button type="ghost" onClick={() => setModalReadyMessages(true)}>
            {selectedMessage ? 'Değiştir...' : 'Seç...'}
          </Button>

          <Modal
            title="Hazır Mesajlarım"
            visible={modalReadyMessages}
            onCancel={() => setModalReadyMessages(false)}
            closeIcon={<CloseIcon />}
            className="modal-ready-messages"
            footer={null}
          >
            <div className="message-list" style={{ maxHeight:'500', overflowY:'scroll'}}>
              <div>En fazla {props.propCount} adet hazır mesaj kayıt edebilirsiniz. Şu an toplam {props.list.length} adet hazır mesajınız bulunmaktadır.</div>
              {props.list.map((item, index) => (
              

                
                <div
                 
                  className="message-list__item"
                  key={'message-item' + index}
                >
                 
                 
                  <p>{item.message}</p>
                
                   
                  <div >
                   <span  onClick={() => {
                    selectMessage(item.message);
                    setModalReadyMessages(false);
                  }}>Seç</span>
                   <span  onClick={() => {
                    props.onDelete(item.msgTypeId);
                  }}>Sil</span>
                   
                   
                  </div>
                </div>
              ))}
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};

SelectFile.defaultProps = {
  fileList: [],
  typeName: 'file',
};

export default SelectFile;
